import {action, observable, runInAction} from 'mobx';
import userStore from '../../stores/UserStore';
import {go, queryParamStringToObject} from '../../utils/navigationUtility';
import {customEvent} from '../../utils/analyticsUtil';
import {actions, category, events} from '../../constants/enums';
import {getEmail} from '../../utils/userUtility';

class RegistrationStore {
    @observable isAuthenticating = false;
    @observable isGoogleSocialAuth = false;
    @observable isFbSocialAuth = false;
    @observable buttonTitle = 'Login';
    @observable navigateUrl = '/auth/login';
    @observable error = null;
    @observable role = null;

    constructor() {
        window.socialRedirect = this.socialAuthRedirect;
        this.numTries = 0;
    }

    @action socialLogin = (provider, context) => {
        if (context === 'SignUp') {
            customEvent(events.CustomEvent, {category: category.SignUp, action: actions.Click, label: provider});
        } else {
            customEvent(events.CustomEvent, {category: category.Login, action: actions.Click, label: provider});
        }
        switch (provider) {
            case 'Facebook':
                this.isFbSocialAuth = true;
                break;
            case 'Google':
                this.isGoogleSocialAuth = true;
                break;
            default:
        }
        this.isAuthenticating = true;
        setTimeout(() => {
            runInAction(() => {
                this.isAuthenticating = false;
                this.isFbSocialAuth = false;
                this.isGoogleSocialAuth = false;
            })
        }, 20000);

        // const provider = 'Facebook';
        const clientId = userStore.getPoolData().ClientId;
        const redirectUrl = userStore.getPoolData().RedirectUrl;
        const state = this.encodeState({date: Date.now(), email: getEmail(), context});
        let win = window.open(
            `https://auth.musico.io/oauth2/authorize?identity_provider=${provider}&redirect_uri=${redirectUrl}&` +
            `response_type=code&state=${state}&client_id=${clientId}&scope=aws.cognito.signin.user.admin%20email%20openid`,
            `${provider} Login`,
            'width=626,height=436'
        );
        // give the window some time to load and add the unload function
        setTimeout(() => {
            try {
                win.onbeforeunload = this.socialCloseWindow;
            } catch (err) {
            }


        }, 1000)
    };

    @action
    setRole(role) {
        this.role = role;
    }

    @action
    setTeacherId(teacherId) {
        this.teacherId = teacherId;
    }

    @action
    setGroupId(groupId) {
        this.groupId = groupId;
    }

    decodeState(state) {
        try {
            return JSON.parse(atob(decodeURIComponent(state)));
        } catch (err) {
            return null;
        }
    }

    encodeState(state) {
        return btoa(JSON.stringify(state));
    }

    @action socialCloseWindow = () => {
        this.error = 'Authentication failed, please try again';
        this.isFbSocialAuth = false;
        this.isGoogleSocialAuth = false;
        this.isAuthenticating = false;
    }

    @action socialAuthRedirect = async (queryString) => {
        console.log(queryString);
        const resp = queryParamStringToObject(queryString.substr(1));
        if (resp.error && resp.error_description && resp.error_description.indexOf('Already+found+an+entry') >= 0) {
            // error_description=Already+found+an+entry+for+username+Facebook_101955177483820+%28Service%3A+
            // AWSCognitoIdentityProviderInternalService%3B+Status+Code%3A+400%3B+Error+Code%3A+AliasExistsException%3B+
            // Request+ID%3A+eab5a712-e1df-11e8-b7e1-d394723f934c%29
            // &state=c4jH6BBwDqS35s2xGjc8dtkJims35JsR&error=access_denied
            this.numTries += 1;
            const provider = (resp.error_description.match('Facebook') || resp.error_description.match('Google') || [])[0];
            if (this.numTries < 2 && provider) {
                setTimeout(() => {
                    this.socialLogin(provider);
                }, 0);
                return;
            }
        }
        try {
            if (resp.error && resp.error_description && resp.error_description.indexOf('Request expired') >= 0) {
                throw new Error('Request expired, please try again');
            }
            // ?error_description=PreSignUp+failed+with+error+%7B%22message%22%3A%22User+already+exists+cannot+signup+using+social+auth%22%7D.+&state=eyJkYXRlIjoxNjEwMzE5Nzg0MjE2fQ%3D%3D&error=invalid_request
            console.log(decodeURIComponent(resp.error_description));
            if (resp.error && resp.error_description && resp.error_description.indexOf('PreSignUp+failed+with+error') >= 0 &&
                resp.error_description.indexOf('User+already+exists+cannot+signup+using+social+auth') >= 0) {
                throw new Error('User does not exists, please go to Signup page');
            }
            if (resp.error) {
                throw new Error('Error during login, please try again');
            }
            // const state = this.decodeState(resp.state);
            // if (state && state.email && state.context === 'Calendar') {
            //     // we might need to connect the user :-(
            //     // userStore.
            //     let data = await userStore.getAccessTokenFromCognito(resp);
            //     let email = data.payload['cognito:username'];
            //     let refreshToken = await request(SIGNUP_GOOGLE_AUTH, {method: 'POST', body: {googleUsername: email}});
            //     userStore.setUserAttribute('google_refresh_token', refreshToken);
            //     debugger;
            // } else {
            await userStore.socialAuth(resp, this.role, this.teacherId, this.groupId);
            // }
            this.numTries = 0;
            runInAction(() => {
                this.isFbSocialAuth = false;
                this.isGoogleSocialAuth = false;
                if (window.socialAuthCallback) {
                    window.socialAuthCallback();
                } else {
                    go('/');
                }
            });
        } catch (err) {
            runInAction(() => {
                this.error = err.message;
                this.isFbSocialAuth = false;
                this.isGoogleSocialAuth = false;
                this.isAuthenticating = false;
            });
        }
    };

    @action
    setRegistrationNavigationData(url, title) {
        this.buttonTitle = title;
        this.navigateUrl = `/auth/${url}`;
    }

    set authenticating(val) {
        this.isAuthenticating = val;
    }

    get authenticating() {
        return this.isAuthenticating;
    }

    // /**
    //  * Perform login with social network
    //  * @param data  {Object}    Data from the social item selected
    //  */
    // @action socialAuth = (data) => {
    //     this.authenticating = true;
    //     updateAwsCredentials(data).then(resp => {
    //         userStore.authSuccess(resp);
    //         this.authenticating = false;
    //         go('/home/students');
    //     }).catch(err => {
    //         this.authenticating = false;
    //         this.error = err;
    //     });
    // }
}

const registrationStore = new RegistrationStore();
export default registrationStore;

